// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"40":"2795f8b4","158":"da9051dd","489":"c7848e2c","710":"799bfdcc","757":"465606ea","854":"2815d4b1","927":"22b1450e"}[chunkId] + ".chunk.css";
};